import React, { useRef, useEffect } from 'react';

const LiveChat = () => {
  const instance = useRef(null);

  useEffect(() => {
    const scriptTag = document.createElement('script');
    scriptTag.src = 'https://172.18.113.135:9443/clientweb/chat-client-v4/js/init.js';
    instance.current.appendChild(scriptTag);
  }, []);
  return (
    <>
      <h1>My Live Chat</h1>
      <div ref={instance} style={{ height: 50, backgroundColor: 'blue' }} />
    </>
  );
};

export default LiveChat;
